import { render, staticRenderFns } from "./NurnbergHowTo.vue?vue&type=template&id=57ee1fdf&"
import script from "./NurnbergHowTo.vue?vue&type=script&lang=js&"
export * from "./NurnbergHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports